import { useMemo } from "react";
import { useNavigate } from "react-router";

import TileTitle from "ds/components/Tile/Title";
import Badge from "ds/components/Badge";
import { IconComponent } from "types/Icon";
import TileWrapper from "ds/components/Tile/Wrapper";
import TileContent from "ds/components/Tile/Content";
import IconEmphasized from "ds/components/IconEmphasized";
import TileIndicator from "ds/components/Tile/Indicator";
import Box from "ds/components/Box";
import { ChevronRight } from "components/icons/generated";
import Icon from "ds/components/Icon";
import { AnalyticsPageLaunchpad } from "hooks/useAnalytics/pages/launchpad";
import useAnalytics from "hooks/useAnalytics";

type GetStartedChecklistFeatureTileProps = {
  title: string;
  icon: IconComponent;
  to: string;
  isCompleted: boolean;
  analyticsTitle: string;
};

const GetStartedChecklistFeatureTile = ({
  title,
  isCompleted,
  icon,
  to,
  analyticsTitle,
}: GetStartedChecklistFeatureTileProps) => {
  const trackSegmentAnalyticsEvent = useAnalytics({
    page: AnalyticsPageLaunchpad.Launchpad,
  });

  const navigate = useNavigate();

  const handleClick = () => {
    trackSegmentAnalyticsEvent(analyticsTitle);
    navigate(to);
  };

  const indicatorComponent = useMemo(() => {
    if (isCompleted) {
      return <Badge variant="blue" type="strong" text="Complete" />;
    }

    return <Icon src={ChevronRight} />;
  }, [isCompleted]);

  return (
    <TileWrapper selected={isCompleted} onClick={isCompleted ? undefined : handleClick}>
      <Box align="center" justify="between" grow="1">
        <TileContent direction="row" align="center">
          <IconEmphasized icon={icon} color={isCompleted ? "selected" : "gray"} />
          <TileTitle>{title}</TileTitle>
        </TileContent>
        <TileIndicator indicator={indicatorComponent} />
      </Box>
    </TileWrapper>
  );
};

export default GetStartedChecklistFeatureTile;
